import styled from 'styled-components/macro'
import { Stack } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const StackMotion = motion(Stack)

export const StyleMessengerBlock = styled(Stack)`
  position: relative;
`

export const StyleNumUnread = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: ${(props) => (props.numUnread > 9 ? 'translate(-15%, -52.5%)' : 'translate(-30%, -52%)')};
  font-size: 15px;
  color: red;
  cursor: pointer;
`
